import React from 'react'

import {
	BaseNotification,
	NotificationVariants,
} from '../../types/notifications'
import {
	SvgAlert,
	SvgChat,
	TaskSvg,
	CalendarSvg,
} from '../../pages/Dashboard/assets/icons'

interface NotificationsListCommonInterface {
	[key: string]: Array<{ [key: string]: any }>
}

export const getIcon = (type: NotificationVariants): React.ReactNode => {
	switch (type) {
		case 'latestTasks':
			return TaskSvg
		case 'latestRealTimeAlerts':
			return SvgAlert
		case 'latestCalenderEvents':
			return CalendarSvg
		case 'latestChats':
			return SvgChat
		default:
			return null
	}
}
export const getTitle = (el: BaseNotification): string => {
	let title = ''

	switch (el?.type) {
		case 'latestTasks':
			title = el?.title || ''
			break
		case 'latestRealTimeAlerts':
			title = 'You have a new realtime alert'
			break
		case 'latestCalenderEvents':
			title = el.title || ''
			break
		case 'latestChats':
			title = 'You have a new chat waiting'
			break
		default:
			title = ''
	}
	return title
}

export const getBaseNotifications = <
	T extends NotificationsListCommonInterface
>(
	data: T
): BaseNotification[] => {
	const baseNotifications: BaseNotification[] = []

	for (const key in data) {
		if (!data[key]?.length) continue

		for (const notification of data[key]) {
			baseNotifications.push({
				title:
					notification.description?.title ||
					notification.details?.title ||
					'',
				message:
					notification.description?.text ||
					notification.details?.description ||
					'',
				dueDate:
					notification.details?.end_time ||
					notification.settings?.dueDate ||
					notification.op?.addedTimestamp ||
					'',
				type: key,
			})
		}
	}

	return baseNotifications
}
